module.exports = __webpack_public_path__ + "static/notification.d4a1c942.png";